"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragAndDropPhases = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _Phase = require("../../molecules/Phase");

var _ButtonV = require("../../atoms/ButtonV2");

var _Modal = require("../Modal");

var _axios = _interopRequireDefault(require("axios"));

var _jsxRuntime = require("react/jsx-runtime");

var DragAndDropPhases = function DragAndDropPhases(_ref) {
  var token = _ref.token;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      draggedItem = _useState2[0],
      setDraggedItem = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      listPhases = _useState4[0],
      setListPhases = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      tempListPhases = _useState6[0],
      setTempListPhases = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      search = _useState8[0],
      setSearch = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      newPhaseName = _useState10[0],
      setNewPhaseName = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      inputValue = _useState12[0],
      setInputValue = _useState12[1];

  var _useState13 = (0, _react.useState)({
    show: false,
    title: "Actualización completa",
    message: "",
    icon: "success"
  }),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      modalData = _useState14[0],
      setModalData = _useState14[1];

  var newPhaseNameRef = (0, _react.useRef)("");
  (0, _react.useEffect)(function () {
    return loadData();
  }, []);
  (0, _react.useEffect)(function () {
    setNewPhaseName(function (prev) {
      return prev + inputValue;
    });
  }, [inputValue]);
  (0, _react.useEffect)(function () {
    newPhaseNameRef.current = search;
  }, [newPhaseName]);

  var handleInputChange = function handleInputChange(e) {
    setInputValue(e.target.value);
  };

  var onDragStart = function onDragStart(e, id) {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", e.target.parentNode);
    e.dataTransfer.setDragImage(e.target.parentNode, 20, 20);
    setDraggedItem(id);
  };

  var onDragOver = function onDragOver(index) {
    var draggedIdx = tempListPhases.findIndex(function (phase) {
      return phase.phaseId === draggedItem;
    });
    var draggedItemData = tempListPhases[draggedIdx];
    var targetIdx = index;
    var newTempListPhases = (0, _toConsumableArray2.default)(tempListPhases);
    newTempListPhases.splice(draggedIdx, 1);
    newTempListPhases.splice(targetIdx, 0, draggedItemData);
    setTempListPhases(newTempListPhases);
  };

  var onDragEnd = function onDragEnd() {
    setDraggedItem(null);
  };

  var updatePhases = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var updateData, response;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              updateData = {
                updateReferencesOfNodes: listPhases.map(function (phase) {
                  return {
                    name: phase.phaseName,
                    isInitialPhase: phase.isInitialPhase,
                    phaseId: phase.phaseId,
                    nextPhaseIfApproved: phase.nextPhaseIfApproved
                  };
                })
              };
              _context.next = 4;
              return _axios.default.post("".concat(process.env.REACT_APP_PHASES_ENDPOINT, "/update"), updateData, {
                headers: {
                  Authorization: token
                }
              });

            case 4:
              response = _context.sent;
              console.log("Update response:", response.body.data);
              loadData();
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.error("Error al actualizar fases", _context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function updatePhases() {
      return _ref2.apply(this, arguments);
    };
  }();

  var addPhase = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(search) {
      var body, response, createdPhase;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              body = {
                name: search,
                retailerGroupsIds: [],
                nextPhaseId: null
              };
              _context2.next = 4;
              return _axios.default.post("".concat(process.env.REACT_APP_PHASES_ENDPOINT, "/create"), body, {
                headers: {
                  Authorization: token
                }
              });

            case 4:
              response = _context2.sent;
              createdPhase = response.data.body;
              console.log(createdPhase);
              setSearch();
              setInputValue("");
              loadData();
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              console.error("Error al agregar fase:", _context2.t0);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 12]]);
    }));

    return function addPhase(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var deletePhase = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(id, phases) {
      var response;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _axios.default.post("".concat(process.env.REACT_APP_PHASES_ENDPOINT, "/delete"), {
                updateReferencesOfNodes: phases,
                deletePhase: id
              }, {
                headers: {
                  Authorization: token
                }
              });

            case 3:
              response = _context3.sent;
              loadData();
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.error("Error al eliminar fase:", _context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));

    return function deletePhase(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleAddPhaseButton = function handleAddPhaseButton() {
    setModalData({
      show: true,
      className: "modal-add-phase",
      title: "Agregar fase de revisión",
      buttons: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "white",
        label: "Cancelar",
        size: 12,
        onClick: function onClick() {
          setModalData(function (prev) {
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, prev), {}, {
              show: false
            });
          });
        }
      }, "btn-Cancelar"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "pink",
        label: "Guardar",
        size: 12,
        onClick: function onClick() {
          setModalData(function (prev) {
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, prev), {}, {
              show: false
            });
          });
          handleSavePhase(search);
        }
      }, "btn-Guardar")],
      customComponent: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "container-input-name",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          children: ["Las fases nuevas siempre se agregan al final.", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), "Puedes ordenar las fases arrastr\xE1ndolas."]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "text",
          className: "input-phases",
          onChange: function onChange(e) {
            setSearch(e.target.value);
            handleInputChange(e);
          },
          value: search,
          placeholder: "Nombre de fase"
        })]
      })
    });
  };

  var handleSavePhase = function handleSavePhase() {
    addPhase(newPhaseNameRef.current);
    setInputValue("");
  };

  var loadData = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var response, phasesData, phasesDataArray;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _axios.default.post("".concat(process.env.REACT_APP_PHASES_ENDPOINT, "/get"), {}, {
                headers: {
                  Authorization: token
                }
              });

            case 3:
              response = _context4.sent;
              phasesData = JSON.parse(response.data.body).data;
              phasesDataArray = [];
              phasesData.forEach(function (_ref6) {
                var phaseId = _ref6.phaseId,
                    phaseName = _ref6.phaseName,
                    isInitialPhase = _ref6.isInitialPhase,
                    nextPhaseIfApproved = _ref6.nextPhaseIfApproved,
                    groups = _ref6.groups;
                var groupsAssigned = groups.map(function (_ref7) {
                  var id = _ref7.id,
                      name = _ref7.name,
                      active = _ref7.active;
                  return {
                    groupId: id,
                    groupName: name,
                    groupActive: active
                  };
                });
                phasesDataArray.push({
                  phaseId: phaseId,
                  phaseName: phaseName,
                  isInitialPhase: isInitialPhase,
                  nextPhaseIfApproved: nextPhaseIfApproved,
                  groupsAssigned: groupsAssigned
                });
              });
              setListPhases(phasesDataArray);
              setTempListPhases(phasesDataArray);
              _context4.next = 14;
              break;

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](0);
              console.error("Error al obtener fases:", _context4.t0);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 11]]);
    }));

    return function loadData() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleDeletePhase = function handleDeletePhase(id) {
    var updatedListPhases = (0, _toConsumableArray2.default)(listPhases);
    var filteredPhases = updatedListPhases.filter(function (phase) {
      return phase.phaseId !== id;
    });
    setListPhases(filteredPhases);
    setModalData({
      show: true,
      className: "modal-delete-phase",
      message: "Fase eliminada correctamente.",
      icon: "successv2",
      buttons: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "pink",
        label: "Aceptar",
        size: 12,
        onClick: function onClick() {
          setModalData(function (prev) {
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, prev), {}, {
              show: false
            });
          });
        }
      }, "btn-Aceptar")]
    });
    deletePhase(id, filteredPhases);
  };

  var renderPhase = function renderPhase(phase, idx) {
    if (phase.isInitialPhase === 1) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Phase.Phase, {
        id: idx,
        phaseId: phase.phaseId,
        phases: listPhases,
        phaseName: phase.phaseName,
        nextPhase: phase.nextPhaseIfApproved,
        groups: phase.groupsAssigned,
        onDeletePhase: function onDeletePhase() {
          return handleDeletePhase(phase.phaseId);
        },
        token: token,
        showMenu: false,
        showButtonChip: false
      }, phase.phaseId);
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Phase.Phase, {
        id: idx,
        phaseId: phase.phaseId,
        phases: listPhases,
        phaseName: phase.phaseName,
        nextPhase: phase.nextPhaseIfApproved,
        groups: phase.groupsAssigned,
        onDeletePhase: function onDeletePhase() {
          return handleDeletePhase(phase.phaseId);
        } // onDragStart={(e) => onDragStart(e, idx)}
        // onDragOver={() => onDragOver(idx)}
        // onDragEnd={onDragEnd}
        ,
        token: token
      }, phase.phaseId);
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Header, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "button-phase",
        onClick: handleAddPhaseButton,
        children: "Agregar fase de revisi\xF3n"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        className: "button-save",
        type: "pink",
        label: "Guardar Cambios",
        size: 12,
        onClick: function onClick() {
          setListPhases(tempListPhases);
          updatePhases();
          setModalData({
            show: true,
            className: "modal-save",
            message: "Cambios aplicados correctamente.",
            icon: "successv2",
            buttons: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
              type: "pink",
              label: "Aceptar",
              size: 12,
              onClick: function onClick() {
                setModalData(function (prev) {
                  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, prev), {}, {
                    show: false
                  });
                });
              }
            }, "btn-Aceptar")]
          });
          loadData();
        }
      }, "btn-Guardar")]
    }), listPhases.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      children: listPhases.map(function (phase, idx) {
        return renderPhase(phase, idx);
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "no-phases-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: "Parece que aun no tienes fases disponibles."
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, modalData), {}, {
      onClickBtnDefault: function onClickBtnDefault() {
        return setModalData(function (prev) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, prev), {}, {
            show: false
          });
        });
      }
    }))]
  });
};

exports.DragAndDropPhases = DragAndDropPhases;